import React from 'react';
import { useMediaQuery } from '@grupoboticario/flora-react-hooks';
import { config } from '@grupoboticario/flora';
var order = ['mobile', 'tablet', 'desktop', 'fullscreen', 'ultrawide'];
var media = Object.keys(config.media).filter(currentMedia => order.includes(currentMedia)).sort((a, b) => order.indexOf(a) - order.indexOf(b));
var onlyMediaList = media.reduce((mediaDict, currentMedia) => {
  var _nextBreakpoint, _nextBreakpoint$repla;

  mediaDict[currentMedia] = config.media[currentMedia];

  if (currentMedia === 'mobile') {
    mediaDict[currentMedia] = config.media[currentMedia].replace(/(\d+)/, '0');
  }

  var currentBreakpoint = order.indexOf(currentMedia);
  var nextBreakpoint = currentBreakpoint > -1 && order[currentBreakpoint + 1] ? order[currentBreakpoint + 1] : -1;
  var minWidth = mediaDict[currentMedia];
  var maxWidth = (_nextBreakpoint = config.media[nextBreakpoint]) == null ? void 0 : (_nextBreakpoint$repla = _nextBreakpoint.replace('min', 'max')) == null ? void 0 : _nextBreakpoint$repla.replace(/(\d+)/, match => "" + (Number(match) - 1));
  mediaDict[currentMedia] = minWidth + (nextBreakpoint ? " and " + maxWidth : '');
  return mediaDict;
}, {});
var fromMediaList = media.reduce((mediaDict, currentMedia) => {
  mediaDict[currentMedia] = config.media[currentMedia];

  if (currentMedia === 'mobile') {
    mediaDict[currentMedia] = config.media[currentMedia].replace(/(\d+)/, '0');
  }

  return mediaDict;
}, {});

/**
 * @component
 * @name Hidden
 * @description Hidden component
 * @tutorial https://flora.gb.tech/docs/components/core/hidden
 */
export var Hidden = _ref => {
  var {
    only,
    from,
    children
  } = _ref;
  var onlyMatcher = !!(only != null && only.map(breakpoint => useMediaQuery(onlyMediaList[breakpoint])).find(breakpoint => breakpoint));
  var fromMatcher = from && !!useMediaQuery(fromMediaList[from]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, onlyMatcher || fromMatcher ? null : children);
};
//# sourceMappingURL=Hidden.js.map